/** Canonical client portal routes — keep email/deep links aligned with App.tsx routing. */
export const CLIENT_PORTAL_HOME_PATH = '/client-portal';
/** Unauthenticated email CTA — SignInPage routes clients to `/client-portal` after login. */
export const CLIENT_SIGN_IN_PATH = '/signin';

export function buildAppUrlPath(appBaseUrl: string, path: string): string {
  const base = appBaseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}

export function buildClientPortalHomeUrl(appBaseUrl: string): string {
  return buildAppUrlPath(appBaseUrl, CLIENT_PORTAL_HOME_PATH);
}

export function buildClientSignInUrl(appBaseUrl: string): string {
  return buildAppUrlPath(appBaseUrl, CLIENT_SIGN_IN_PATH);
}

export function buildClientPortalScheduleUrl(appBaseUrl: string): string {
  return buildAppUrlPath(appBaseUrl, CLIENT_PORTAL_HOME_PATH);
}
